<style lang="scss">
@import "./styles/contact-sub-header.scss";
</style>

<template>
  <div class="contact-stack-title">
    <span>
      {{ title }}
      <v-tooltip max-width="320" close-delay="1000" top>
        <v-btn class="title-tooltip" slot="activator" icon>
          <v-icon class="sleek-icon">help</v-icon>
        </v-btn>
        <span>{{ this.$t("$company.organization.no_edit") }}</span>
      </v-tooltip>
    </span>
    <v-btn flat icon :to="getLinkForEnquiry">
      <v-icon class="contact-edit-icon">edit</v-icon>
    </v-btn>
  </div>
</template>

<script>
import { includes } from "lodash";

// Constants
import { Constants } from "customer-sdk/constants";

const { SLEEK_DOMAINS } = Constants.SLEEK_DOMAINS;
const domain = window.location.hostname;
const isSleekDomain = includes(SLEEK_DOMAINS, domain);

export default {
  props: {
    title: String
  },
  computed: {
    getLinkForEnquiry: function() {
      if (this.title === "Directors") {
        return `${isSleekDomain ? "" : "/partner"}/enquiry/?query=director`;
      } else {
        return `${isSleekDomain ? "" : "/partner"}/enquiry/?query=shareholder`;
      }
    }
  }
};
</script>
